/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { map, size } from 'lodash';
import { Box, Heading, Stack, Text } from '@towersystems/towersystems-design-system';
import page from 'page';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import { requestConnections } from 'state/connections/actions';
import { getAllConnections } from 'state/connections/selectors';
import CreateConnectionModal from './create-connection-modal';
import { createOpenModalAction } from 'state/ui/actions';
import ConnectionsCardGrid from './connections-card-grid';
import GridSkeleton from 'components/skeleton-loader/grid-skeleton';
import Icon from 'components/icon';

const ConnectionsMain = ({ connections, ...props }) => {
    const [requesting, setRequesting] = useState(true);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setRequesting(true);
        try {
            await props.requestConnections();
        } catch (error) {
            console.log('error', error);
        }
        setRequesting(false);
    };

    let items = [
        {
            key: '_new',
            renderer: () => (
                <Box width='full'>
                    <Stack space='medium'>
                        <Box display='flex' alignItems='center' justifyContent='center'>
                            <Box className='connection-type-tag'>
                                <Icon name='FaPlus' />
                            </Box>
                        </Box>
                        <Text size="large" weight='strong' >Create new</Text>
                    </Stack>
                </Box>
            ),
            onClick: () => props.newConnection(),
        },
    ];

    if (true == requesting) {
        return <GridSkeleton />;
    }

    return (
        <Main>
            <Stack space='large'>
                <Heading level='1'>My Connections ({size(connections)})</Heading>
                <ConnectionsCardGrid connections={connections} items={items} />
            </Stack>
            <CreateConnectionModal />
        </Main>
    );
};

export default connect(
    (state) => ({
        connections: getAllConnections(state),
    }),
    {
        requestConnections,
        newConnection: createOpenModalAction('CreateConnectionModal'),
    },
)(ConnectionsMain);
